import styled, { createGlobalStyle } from "styled-components";
import { FlexColumn, FlexRow, RightFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import classNames from "classnames";
import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";
import { ChipItemWrapper, Banner } from "@similarweb/ui-components";
import { identity } from "lodash";

export const FilterContentContainer = styled(FlexColumn)`
    width: 100%;
`;

export const HeaderTitle = styled.div`
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
    margin-bottom: 8px;
`;

export const FilterContentFooter = styled(RightFlexRow)`
    width: 100%;
    padding-top: 8px;
`;

export const Divider = styled.div`
    width: calc(100% + 32px);
    margin: 8px -16px 0;
    height: 1px;
    background-color: ${colorsPalettes.carbon[100]};
`;

export const FilterRuleRow = styled.div<{
    withDeleteButton: boolean;
    withMatchType: boolean;
    ruleSeparatorText: string;
}>`
    position: relative;
    display: grid;
    grid-template-columns: ${({ withDeleteButton, withMatchType }) => {
        return ["110px", withMatchType ? "140px" : undefined, "1fr", withDeleteButton ? "40px" : undefined]
            .filter(identity)
            .join(" ");
    }};
    box-sizing: border-box;
    background-color: ${colorsPalettes.carbon[25]};
    width: 100%;
    gap: 8px;
    padding: 8px;
    margin-bottom: 8px;
    align-items: center;

    /* last child without "add rule" button */
    &:not(:nth-last-child(2)) {
        margin-bottom: 26px;

        &::after {
            content: "${({ ruleSeparatorText }) => ruleSeparatorText}";
            position: absolute;
            bottom: -18px;
            ${setFontVariant("tag", colorsPalettes.carbon[500])};
        }
    }
`;

export const ChipContainerBannerWrapper = styled.div`
    margin-top: 8px;
`;

export const BannerText = styled.div`
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
`;

const AutoCompleteContainer = styled(FlexRow)`
    width: 100%;
    gap: 8px;
    > *:first-child {
        flex: 1;
    }
`;

export const DropdownTitle = styled.div`
    margin-bottom: 6px;
    ${setFontVariant("input2", colorsPalettes.carbon[500])};
`;

export const DropdownDescription = styled.div`
    ${setFontVariant("listItem3", rgba(colorsPalettes.carbon[500], 0.6))};
`;

const AutocompleteKeywordGroupsStyled = styled.div<{ hasSelected: boolean }>`
    margin: 16px 0 16px 0;
    .AutoCompleteContainer {
        border-color: ${rgba(colorsPalettes.carbon[500], 0.2)};
        ${({ hasSelected }) => hasSelected && `border-radius: 0 0 3px 3px`};
    }
`;

export const RuleChipsContainer = styled.div<{ isEmpty?: boolean; $chipSeparator: string }>`
    grid-column: 1/-1;

    ${({ isEmpty }) => isEmpty && "display: none;"}

    ${ChipItemWrapper} {
        position: relative;

        &:not(:last-child) {
            margin-right: 24px;
            &:after {
                content: "${({ $chipSeparator }) => $chipSeparator}";
                position: absolute;
                right: -18px;
                ${setFontVariant("tag", colorsPalettes.carbon[250])};
            }
        }
    }

    .ChipItemText {
        color: ${colorsPalettes.carbon[500]};
    }
`;

export const BannerStyled = styled(Banner)`
    padding: 10px 16px;
`;

export const GlobalStyles = createGlobalStyle`
    .multiIncludeExclude--Popup-container {
        overflow: unset;
        z-index: 1050 !important;
    }
`;
export const FilterWrapper = styled.div`
    padding: 16px;
`;

export const DropdownItem = styled(FlexColumn).attrs<{
    "data-automation-dropdown-item"?: boolean;
    isSelected?: boolean;
}>((props) => ({
    className: classNames("DropdownItem", {
        "DropdownItem--selected": props.isSelected,
    }),
}))<{ isSelected: boolean; padding?: string }>`
    padding: ${({ padding }) => padding ?? "16px"};
    height: auto;
    text-indent: initial;
    white-space: normal;
`;
